import { Link } from '@heidi/design-system/link';
import { TypographyFootNote } from '@heidi/design-system/typography';
import { cn } from '@heidi/utils';
import { FormattedMessage } from 'react-intl';

import { evidenceRegulatoryMessages } from './evidenceRegulatory.messages';

export interface EvidenceRegulatoryFootnoteProps {
  /**
   * Instructions For Use document for the user's effective Evidence region,
   * resolved by the composition point. `null` when that region ships no IFU,
   * which renders the statement alone.
   */
  ifuHref: string | null;
  className?: string;
}

/**
 * Regulatory labelling that travels with Evidence output wherever it is
 * rendered: the SWR-30 medical-knowledge statement, plus the IFU link when the
 * region has one. Non-dismissible by design.
 */
export const EvidenceRegulatoryFootnote = ({
  ifuHref,
  className,
}: EvidenceRegulatoryFootnoteProps): JSX.Element => (
  <TypographyFootNote
    className={cn('block text-center text-text-tertiary', className)}
    data-testid="evidence-regulatory-footnote"
  >
    <span data-testid="evidence-regulatory-statement">
      <FormattedMessage {...evidenceRegulatoryMessages.medicalKnowledgeStatement} />
    </span>
    {ifuHref ? (
      <>
        {' '}
        <Link
          href={ifuHref}
          target="_blank"
          rel="noopener noreferrer"
          variant="inline"
          data-testid="evidence-ifu-link"
        >
          <FormattedMessage {...evidenceRegulatoryMessages.instructionsForUse} />
        </Link>
      </>
    ) : null}
  </TypographyFootNote>
);
